import { render, staticRenderFns } from "./SelectLocationsModal.vue?vue&type=template&id=5936316d&scoped=true&"
import script from "./SelectLocationsModal.vue?vue&type=script&lang=js&"
export * from "./SelectLocationsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectLocationsModal.vue?vue&type=style&index=0&id=5936316d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936316d",
  null
  
)

export default component.exports